/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'thats-life': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm1 15H9v2h2v-2zM10 3a1 1 0 00-1 1v8a1 1 0 002 0V4a1 1 0 00-1-1z" _fill="#000" fill-rule="evenodd"/>'
  }
})
